<template>
  <div>
  <!-- Indique si la licence n'a pas l'option Push -->
  <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
    {{ $t('warningPushDisabled') }} 
  </v-alert>
  <div class="display">
    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <!-- Invitation -->
    <v-expansion-panel v-else expand>
      <v-expansion-panel-content
        :disabled="testBrideStatus('parametre_push')"
      >
        <div slot="header"><v-icon class="mr-2 primary--text">announcement</v-icon>{{$t("pushMarketAuto")}}</div>
        <v-card class="mb-3">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <!-- Envoyer automatiquement un push -->
                <v-switch 
                  label="Push Marketing"
                  v-model="push.active"
                  light
                  color="primary">
                </v-switch>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-select
                  v-model="push.id"
                  :items="pushs"
                  :label="$t('select') + ' push' | cap"
                  return-object
                  :disabled="!push.active">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 v-show="push.active">
                <div>{{ $t('triggerConditionTime') }}</div>
                <v-slider 
                  v-model="push.delay"
                  thumb-label
                  :min="0"
                  :max="300"
                ></v-slider>
                <span>{{ push.delay }} sec.</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 v-show="push.active">
                <div>{{ $t('triggerConditionUrl') }}</div>
                <v-switch 
                  :label="$t('restrictFewUrLs')"
                  v-model="push.urlonoff"
                  light
                  color="primary"
                ></v-switch>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 v-show="push.active">
                <v-text-field 
                  v-model="push.url"
                  :label="$t('containsString')"
                  :disabled="!push.urlonoff" 
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- Validation du formulaire -->
    <div class="text-xs-right">
      <v-btn
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        :loading="loadingPost"
        @click.native="postOptions()"
        :disabled="alert"
      >{{ $t('save') | cap }}<v-icon dark right>save</v-icon>
      </v-btn>
    </div>
    </div>
    <!-- dialog progress bar installation -->
    <wz-dialog-progress
      @fermeDialogProgress="fermeDialogProgress"
      :dialogProgress="dialogProgress"
      :etape=10
    >
    </wz-dialog-progress>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data () {
    return {
      alert: false,
      push: {
        active: false,
        id: '',
        lang: 'FR',
        urlonoff: '0',
        url: '',
        delay: '0'
      },

      // loaders
      loadingGet: false,
      loadingPost: false,
      test: {},
      pushs: [],
      resAjx: null,
      dialogProgress: false
    }
  },
  mounted () {
    this.init()
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress()
    }
  },
  created () {
    this.getOptions()
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_bluepush'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_bluepush'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  methods: {
    init () {
      if (this.$store.state._User.entLevel !== '7' && this.$store.state._User.entOptionPush === 0) {
        this.alert = true
        return
      }
      this.resAjx = null
      this.axios
        .get('get/pushs.php')
        .then(response => {
          this.resAjx = response.data
        })
        .then(_ => {
          for (let i = 0; i < this.resAjx.length; ++i) {
            this.pushs.push({
              text: this.resAjx[i].PUSH_NAME,
              value: this.resAjx[i].PUSH_ID
            })
          }
        })
        .catch()
    },
    getOptions () {
      this.loadingGet = true
      this.axios
        .get(
          'get/settings_push.php?desk=' +
            this.$store.state._Sites.siteSelected.LIC_DSK_ID
        )
        .then(response => {
          this.push.active = response.data.DSK_PUSH_ONOFF === '1'
          this.push.delay = response.data.DSK_PUSH_DELAY
          this.push.urlonoff = response.data.DSK_PUSH_URL_ONOFF === '1'
          this.push.url = response.data.DSK_PUSH_URL
          this.push.id = response.data.DSK_PUSH_ID
          this.test.DSK_PUSH_ONOFF = response.data.DSK_PUSH_ONOFF
          this.test.DSK_PUSH_DELAY = response.data.DSK_PUSH_DELAY
          this.test.DSK_PUSH_URL_ONOFF = response.data.DSK_PUSH_URL_ONOFF
          this.test.DSK_PUSH_URL = response.data.DSK_PUSH_URL
          this.test.DSK_PUSH_ID = response.data.DSK_PUSH_ID
        })
        .catch(_ => {})
        .then(_ => {
          this.loadingGet = false
        })
    },

    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
    },

    postOptions () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      dataToPost.append(
        'DSK_ID',
        this.$store.state._Sites.siteSelected.LIC_DSK_ID
      )
      dataToPost.append(
        'LIC_KEY',
        this.$store.state._Sites.siteSelected.LIC_KEY
      )

      dataToPost.append('DSK_PUSH_ONOFF', this.push.active ? '1' : '0')
      dataToPost.append('DSK_PUSH_DELAY', this.push.delay)
      dataToPost.append('DSK_PUSH_URL', this.push.url)
      dataToPost.append('DSK_PUSH_URL_ONOFF', this.push.urlonoff ? '1' : '0')
      // tantot {'text':blabla',value':'42'} tantot 42
      if (typeof (this.push.id.value) !== 'undefined' && this.push.id.value) {
        dataToPost.append('DSK_PUSH_ID', this.push.id.value)
      } else {
        dataToPost.append('DSK_PUSH_ID', this.push.id)
      }
      this.loadingPost = true
      this.axios
        .post('post/settings_push.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          let siteUpdate = _.clone(this.$store.state._Sites.siteSelected)
          this.$store.commit('_Sites/UPDATE_SITE_SETTINGS', siteUpdate)
          this.$store.commit('_Sites/UPDATE_SITE_SELECTED', siteUpdate)
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      if (v) {
        this.getOptions()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/BluePush.vue